import React from "react";
import styled from "styled-components";
import Text from "../atoms/Text";
import Button from "../atoms/Button";
import { COLOR_SYSTEM } from "../design/design-system";

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  border-bottom: 1px solid ${COLOR_SYSTEM.get("Gray")?.[50]};
  height: 72px;
  box-sizing: border-box;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  height: 32px;
`;

const ServiceName = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

const ActionSection = styled.div`
  display: flex;
  gap: 12px;
`;

interface NavigationHeaderProps {
  onLogin?: () => void; // optional: 랜딩 페이지에서만 사용
}

const NavigationHeader: React.FC<NavigationHeaderProps> = ({ onLogin }) => {
  return (
    <HeaderContainer>
      <LogoSection>
        <Logo src="/images/logo.png" alt="약문약답 로고" />
        <ServiceName>PhAI</ServiceName>
      </LogoSection>
      {onLogin && (
        <ActionSection>
          <Button
            type="Text"
            size="Medium"
            variant="Contained"
            color="Primary"
            onClick={onLogin}
          >
            로그인
          </Button>
        </ActionSection>
      )}
    </HeaderContainer>
  );
};

export default NavigationHeader;
